import jasperLakeBackground from '@/../public/_n/images/jasper-lake.webp';
import Image from '@/components/image/NextImage';

import {
	BackgroundImageWrapper,
	BackgroundWrapper,
	Container,
	DimmingOverlay,
	GradientOverlay,
} from './styles';

interface Props {
	children?: React.ReactNode;
	shouldDim?: boolean;
	className?: string;
}

const Layout = ({ shouldDim, className, children }: Props) => {
	return (
		<Container className={className}>
			<BackgroundWrapper>
				<BackgroundImageWrapper>
					<Image layout="fill" objectFit="cover" objectPosition="50% 10%" src={jasperLakeBackground} />
				</BackgroundImageWrapper>
				<GradientOverlay />
				{shouldDim ? <DimmingOverlay /> : null}
			</BackgroundWrapper>
			{children}
		</Container>
	);
};

export default Layout;
